/**
 * VENDOR MODULES
 */
import React from 'react';
import { useTranslation } from 'react-i18next';

import { getCdnAssetUrl } from 'shared/utils/cdn';

/**
 * NoEventsScreen Component
 *
 * Displays a full-screen message when no virtual events are available.
 * Positioned relative to the app root container so it does not cover platform shell when embedded.
 */
function NoEventsScreen() {
  const { t } = useTranslation();

  const imageUrl = getCdnAssetUrl('assets/images/virtual-sports/no-virtual-events.png');

  return (
    <div
      style={{
        position: 'absolute',
        inset: 0,
        backgroundImage: `url(${imageUrl})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 10,
        overflow: 'visible',
      }}
    >
      <div
        style={{
          textAlign: 'center',
          padding: '2rem 3rem',
          backgroundColor: 'rgba(0, 0, 0, 0.7)',
          borderRadius: '10px',
          maxWidth: '95%',
          width: 'fit-content',
          minWidth: '300px',
          boxSizing: 'border-box',
          overflow: 'visible',
        }}
      >
        <p
          className="text-lg font-bold"
          style={{
            color: '#fff',
            margin: 0,
            wordWrap: 'break-word',
            overflowWrap: 'break-word',
            whiteSpace: 'normal',
            lineHeight: 1.5,
            overflow: 'visible',
            textOverflow: 'clip',
            display: 'block',
            width: '100%',
          }}
        >
          {t('NO_EVENTS_MESSAGE')}
        </p>
      </div>
    </div>
  );
}

export default NoEventsScreen;
